/**
 * Page context the Admin Portal collects for the embedded AI Ops chat. The embed reads these
 * fields off the postMessage payload, so the shape has to stay in step with the chat app.
 */
export interface ThreadContextSnapshot {
  customerId: string | null;
  customerName: string | null;
  orderId: string | null;
  department: string | null;
  page: string | null;
}

export function hasMeaningfulContext(snapshot: ThreadContextSnapshot | null | undefined): boolean {
  if (!snapshot) {
    return false;
  }

  return Boolean(
    snapshot.customerId || snapshot.customerName || snapshot.orderId || snapshot.department || snapshot.page,
  );
}
